export default __webpack_public_path__ + "static/media/facebook.c1201ca9.svg";